'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _trafficManager = require('../traffic-manager');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Overlay = function Overlay() {
  _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.multitab.block', []);

  return _react2.default.createElement(
    'div',
    {
      className: 'help--overlay',
      style: {
        backgroundColor: '#FFFFFF',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        zIndex: '999'
      }
    },
    _react2.default.createElement(
      'div',
      {
        style: {
          padding: '1rem',
          textAlign: 'center'
        }
      },
      _react2.default.createElement(
        'h1',
        {
          style: {
            marginBottom: '2rem'
          }
        },
        'Hi! Looks like you\'re already chatting with a GoDaddy Guide.'
      ),
      _react2.default.createElement('div', {
        style: {
          background: 'linear-gradient(45deg, #177ad0, #9c48b3)',
          height: '5px',
          marginBottom: '2rem'
        }
      }),
      _react2.default.createElement(
        'p',
        null,
        'We don\'t want to mess up your connection, so please continue your conversation in the original window or tab.'
      )
    )
  );
};

Overlay.propTypes = {};

exports.default = Overlay;